/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthedRouteImport } from "./routes/_authed"
import { Route as SignInRouteImport } from "./routes/sign-in"
import { Route as AuthedAuditLogIndexRouteImport } from "./routes/_authed/audit-log/index"
import { Route as AuthedBridgeIndexRouteImport } from "./routes/_authed/bridge/index"
import { Route as AuthedBridgeShopifyOrderIdRouteImport } from "./routes/_authed/bridge/$shopifyOrderId"
import { Route as AuthedCallbacksIndexRouteImport } from "./routes/_authed/callbacks/index"
import { Route as AuthedCallbacksDeliveryIdRouteImport } from "./routes/_authed/callbacks/$deliveryId"
import { Route as AuthedDisbursementsIndexRouteImport } from "./routes/_authed/disbursements/index"
import { Route as AuthedDisbursementsDisbursementIdRouteImport } from "./routes/_authed/disbursements/$disbursementId"
import { Route as AuthedMerchantsIndexRouteImport } from "./routes/_authed/merchants/index"
import { Route as AuthedMerchantsMerchantIdRouteImport } from "./routes/_authed/merchants/$merchantId"
import { Route as AuthedPaymentConflictsIndexRouteImport } from "./routes/_authed/payment-conflicts/index"
import { Route as AuthedSettlementsIndexRouteImport } from "./routes/_authed/settlements/index"
import { Route as AuthedSettlementsSettlementIdRouteImport } from "./routes/_authed/settlements/$settlementId"
import { Route as AuthedStorefrontsIndexRouteImport } from "./routes/_authed/storefronts/index"
import { Route as AuthedStorefrontsStorefrontIdRouteImport } from "./routes/_authed/storefronts/$storefrontId"
import { Route as AuthedStorefrontsNewRouteImport } from "./routes/_authed/storefronts/new"
import { Route as AuthedTransactionsIndexRouteImport } from "./routes/_authed/transactions/index"
import { Route as AuthedTransactionsOrderIdRouteImport } from "./routes/_authed/transactions/$orderId"
import { Route as AuthedWebhookEventsIndexRouteImport } from "./routes/_authed/webhook-events/index"
import { Route as AuthedWebhookEventsEventIdRouteImport } from "./routes/_authed/webhook-events/$eventId"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAuditLogIndexRoute = AuthedAuditLogIndexRouteImport.update({
  id: "/audit-log/",
  path: "/audit-log/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBridgeIndexRoute = AuthedBridgeIndexRouteImport.update({
  id: "/bridge/",
  path: "/bridge/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBridgeShopifyOrderIdRoute =
  AuthedBridgeShopifyOrderIdRouteImport.update({
    id: "/bridge/$shopifyOrderId",
    path: "/bridge/$shopifyOrderId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCallbacksIndexRoute = AuthedCallbacksIndexRouteImport.update({
  id: "/callbacks/",
  path: "/callbacks/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCallbacksDeliveryIdRoute =
  AuthedCallbacksDeliveryIdRouteImport.update({
    id: "/callbacks/$deliveryId",
    path: "/callbacks/$deliveryId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDisbursementsIndexRoute =
  AuthedDisbursementsIndexRouteImport.update({
    id: "/disbursements/",
    path: "/disbursements/",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDisbursementsDisbursementIdRoute =
  AuthedDisbursementsDisbursementIdRouteImport.update({
    id: "/disbursements/$disbursementId",
    path: "/disbursements/$disbursementId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMerchantsIndexRoute = AuthedMerchantsIndexRouteImport.update({
  id: "/merchants/",
  path: "/merchants/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMerchantsMerchantIdRoute =
  AuthedMerchantsMerchantIdRouteImport.update({
    id: "/merchants/$merchantId",
    path: "/merchants/$merchantId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPaymentConflictsIndexRoute =
  AuthedPaymentConflictsIndexRouteImport.update({
    id: "/payment-conflicts/",
    path: "/payment-conflicts/",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettlementsIndexRoute = AuthedSettlementsIndexRouteImport.update({
  id: "/settlements/",
  path: "/settlements/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettlementsSettlementIdRoute =
  AuthedSettlementsSettlementIdRouteImport.update({
    id: "/settlements/$settlementId",
    path: "/settlements/$settlementId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedStorefrontsIndexRoute = AuthedStorefrontsIndexRouteImport.update({
  id: "/storefronts/",
  path: "/storefronts/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStorefrontsStorefrontIdRoute =
  AuthedStorefrontsStorefrontIdRouteImport.update({
    id: "/storefronts/$storefrontId",
    path: "/storefronts/$storefrontId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedStorefrontsNewRoute = AuthedStorefrontsNewRouteImport.update({
  id: "/storefronts/new",
  path: "/storefronts/new",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTransactionsIndexRoute = AuthedTransactionsIndexRouteImport.update({
  id: "/transactions/",
  path: "/transactions/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTransactionsOrderIdRoute =
  AuthedTransactionsOrderIdRouteImport.update({
    id: "/transactions/$orderId",
    path: "/transactions/$orderId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedWebhookEventsIndexRoute =
  AuthedWebhookEventsIndexRouteImport.update({
    id: "/webhook-events/",
    path: "/webhook-events/",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedWebhookEventsEventIdRoute =
  AuthedWebhookEventsEventIdRouteImport.update({
    id: "/webhook-events/$eventId",
    path: "/webhook-events/$eventId",
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/sign-in": typeof SignInRoute
  "/bridge/$shopifyOrderId": typeof AuthedBridgeShopifyOrderIdRoute
  "/callbacks/$deliveryId": typeof AuthedCallbacksDeliveryIdRoute
  "/disbursements/$disbursementId": typeof AuthedDisbursementsDisbursementIdRoute
  "/merchants/$merchantId": typeof AuthedMerchantsMerchantIdRoute
  "/settlements/$settlementId": typeof AuthedSettlementsSettlementIdRoute
  "/storefronts/$storefrontId": typeof AuthedStorefrontsStorefrontIdRoute
  "/storefronts/new": typeof AuthedStorefrontsNewRoute
  "/transactions/$orderId": typeof AuthedTransactionsOrderIdRoute
  "/webhook-events/$eventId": typeof AuthedWebhookEventsEventIdRoute
  "/audit-log/": typeof AuthedAuditLogIndexRoute
  "/bridge/": typeof AuthedBridgeIndexRoute
  "/callbacks/": typeof AuthedCallbacksIndexRoute
  "/disbursements/": typeof AuthedDisbursementsIndexRoute
  "/merchants/": typeof AuthedMerchantsIndexRoute
  "/payment-conflicts/": typeof AuthedPaymentConflictsIndexRoute
  "/settlements/": typeof AuthedSettlementsIndexRoute
  "/storefronts/": typeof AuthedStorefrontsIndexRoute
  "/transactions/": typeof AuthedTransactionsIndexRoute
  "/webhook-events/": typeof AuthedWebhookEventsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/sign-in": typeof SignInRoute
  "/bridge/$shopifyOrderId": typeof AuthedBridgeShopifyOrderIdRoute
  "/callbacks/$deliveryId": typeof AuthedCallbacksDeliveryIdRoute
  "/disbursements/$disbursementId": typeof AuthedDisbursementsDisbursementIdRoute
  "/merchants/$merchantId": typeof AuthedMerchantsMerchantIdRoute
  "/settlements/$settlementId": typeof AuthedSettlementsSettlementIdRoute
  "/storefronts/$storefrontId": typeof AuthedStorefrontsStorefrontIdRoute
  "/storefronts/new": typeof AuthedStorefrontsNewRoute
  "/transactions/$orderId": typeof AuthedTransactionsOrderIdRoute
  "/webhook-events/$eventId": typeof AuthedWebhookEventsEventIdRoute
  "/audit-log": typeof AuthedAuditLogIndexRoute
  "/bridge": typeof AuthedBridgeIndexRoute
  "/callbacks": typeof AuthedCallbacksIndexRoute
  "/disbursements": typeof AuthedDisbursementsIndexRoute
  "/merchants": typeof AuthedMerchantsIndexRoute
  "/payment-conflicts": typeof AuthedPaymentConflictsIndexRoute
  "/settlements": typeof AuthedSettlementsIndexRoute
  "/storefronts": typeof AuthedStorefrontsIndexRoute
  "/transactions": typeof AuthedTransactionsIndexRoute
  "/webhook-events": typeof AuthedWebhookEventsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authed": typeof AuthedRouteWithChildren
  "/sign-in": typeof SignInRoute
  "/_authed/bridge/$shopifyOrderId": typeof AuthedBridgeShopifyOrderIdRoute
  "/_authed/callbacks/$deliveryId": typeof AuthedCallbacksDeliveryIdRoute
  "/_authed/disbursements/$disbursementId": typeof AuthedDisbursementsDisbursementIdRoute
  "/_authed/merchants/$merchantId": typeof AuthedMerchantsMerchantIdRoute
  "/_authed/settlements/$settlementId": typeof AuthedSettlementsSettlementIdRoute
  "/_authed/storefronts/$storefrontId": typeof AuthedStorefrontsStorefrontIdRoute
  "/_authed/storefronts/new": typeof AuthedStorefrontsNewRoute
  "/_authed/transactions/$orderId": typeof AuthedTransactionsOrderIdRoute
  "/_authed/webhook-events/$eventId": typeof AuthedWebhookEventsEventIdRoute
  "/_authed/audit-log/": typeof AuthedAuditLogIndexRoute
  "/_authed/bridge/": typeof AuthedBridgeIndexRoute
  "/_authed/callbacks/": typeof AuthedCallbacksIndexRoute
  "/_authed/disbursements/": typeof AuthedDisbursementsIndexRoute
  "/_authed/merchants/": typeof AuthedMerchantsIndexRoute
  "/_authed/payment-conflicts/": typeof AuthedPaymentConflictsIndexRoute
  "/_authed/settlements/": typeof AuthedSettlementsIndexRoute
  "/_authed/storefronts/": typeof AuthedStorefrontsIndexRoute
  "/_authed/transactions/": typeof AuthedTransactionsIndexRoute
  "/_authed/webhook-events/": typeof AuthedWebhookEventsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/sign-in"
    | "/bridge/$shopifyOrderId"
    | "/callbacks/$deliveryId"
    | "/disbursements/$disbursementId"
    | "/merchants/$merchantId"
    | "/settlements/$settlementId"
    | "/storefronts/$storefrontId"
    | "/storefronts/new"
    | "/transactions/$orderId"
    | "/webhook-events/$eventId"
    | "/audit-log/"
    | "/bridge/"
    | "/callbacks/"
    | "/disbursements/"
    | "/merchants/"
    | "/payment-conflicts/"
    | "/settlements/"
    | "/storefronts/"
    | "/transactions/"
    | "/webhook-events/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/sign-in"
    | "/bridge/$shopifyOrderId"
    | "/callbacks/$deliveryId"
    | "/disbursements/$disbursementId"
    | "/merchants/$merchantId"
    | "/settlements/$settlementId"
    | "/storefronts/$storefrontId"
    | "/storefronts/new"
    | "/transactions/$orderId"
    | "/webhook-events/$eventId"
    | "/audit-log"
    | "/bridge"
    | "/callbacks"
    | "/disbursements"
    | "/merchants"
    | "/payment-conflicts"
    | "/settlements"
    | "/storefronts"
    | "/transactions"
    | "/webhook-events"
  id:
    | "__root__"
    | "/"
    | "/_authed"
    | "/sign-in"
    | "/_authed/bridge/$shopifyOrderId"
    | "/_authed/callbacks/$deliveryId"
    | "/_authed/disbursements/$disbursementId"
    | "/_authed/merchants/$merchantId"
    | "/_authed/settlements/$settlementId"
    | "/_authed/storefronts/$storefrontId"
    | "/_authed/storefronts/new"
    | "/_authed/transactions/$orderId"
    | "/_authed/webhook-events/$eventId"
    | "/_authed/audit-log/"
    | "/_authed/bridge/"
    | "/_authed/callbacks/"
    | "/_authed/disbursements/"
    | "/_authed/merchants/"
    | "/_authed/payment-conflicts/"
    | "/_authed/settlements/"
    | "/_authed/storefronts/"
    | "/_authed/transactions/"
    | "/_authed/webhook-events/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed": {
      id: "/_authed"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-in": {
      id: "/sign-in"
      path: "/sign-in"
      fullPath: "/sign-in"
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/audit-log/": {
      id: "/_authed/audit-log/"
      path: "/audit-log"
      fullPath: "/audit-log/"
      preLoaderRoute: typeof AuthedAuditLogIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/bridge/": {
      id: "/_authed/bridge/"
      path: "/bridge"
      fullPath: "/bridge/"
      preLoaderRoute: typeof AuthedBridgeIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/bridge/$shopifyOrderId": {
      id: "/_authed/bridge/$shopifyOrderId"
      path: "/bridge/$shopifyOrderId"
      fullPath: "/bridge/$shopifyOrderId"
      preLoaderRoute: typeof AuthedBridgeShopifyOrderIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/callbacks/": {
      id: "/_authed/callbacks/"
      path: "/callbacks"
      fullPath: "/callbacks/"
      preLoaderRoute: typeof AuthedCallbacksIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/callbacks/$deliveryId": {
      id: "/_authed/callbacks/$deliveryId"
      path: "/callbacks/$deliveryId"
      fullPath: "/callbacks/$deliveryId"
      preLoaderRoute: typeof AuthedCallbacksDeliveryIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/disbursements/": {
      id: "/_authed/disbursements/"
      path: "/disbursements"
      fullPath: "/disbursements/"
      preLoaderRoute: typeof AuthedDisbursementsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/disbursements/$disbursementId": {
      id: "/_authed/disbursements/$disbursementId"
      path: "/disbursements/$disbursementId"
      fullPath: "/disbursements/$disbursementId"
      preLoaderRoute: typeof AuthedDisbursementsDisbursementIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/merchants/": {
      id: "/_authed/merchants/"
      path: "/merchants"
      fullPath: "/merchants/"
      preLoaderRoute: typeof AuthedMerchantsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/merchants/$merchantId": {
      id: "/_authed/merchants/$merchantId"
      path: "/merchants/$merchantId"
      fullPath: "/merchants/$merchantId"
      preLoaderRoute: typeof AuthedMerchantsMerchantIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/payment-conflicts/": {
      id: "/_authed/payment-conflicts/"
      path: "/payment-conflicts"
      fullPath: "/payment-conflicts/"
      preLoaderRoute: typeof AuthedPaymentConflictsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/settlements/": {
      id: "/_authed/settlements/"
      path: "/settlements"
      fullPath: "/settlements/"
      preLoaderRoute: typeof AuthedSettlementsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/settlements/$settlementId": {
      id: "/_authed/settlements/$settlementId"
      path: "/settlements/$settlementId"
      fullPath: "/settlements/$settlementId"
      preLoaderRoute: typeof AuthedSettlementsSettlementIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/storefronts/": {
      id: "/_authed/storefronts/"
      path: "/storefronts"
      fullPath: "/storefronts/"
      preLoaderRoute: typeof AuthedStorefrontsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/storefronts/$storefrontId": {
      id: "/_authed/storefronts/$storefrontId"
      path: "/storefronts/$storefrontId"
      fullPath: "/storefronts/$storefrontId"
      preLoaderRoute: typeof AuthedStorefrontsStorefrontIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/storefronts/new": {
      id: "/_authed/storefronts/new"
      path: "/storefronts/new"
      fullPath: "/storefronts/new"
      preLoaderRoute: typeof AuthedStorefrontsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/transactions/": {
      id: "/_authed/transactions/"
      path: "/transactions"
      fullPath: "/transactions/"
      preLoaderRoute: typeof AuthedTransactionsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/transactions/$orderId": {
      id: "/_authed/transactions/$orderId"
      path: "/transactions/$orderId"
      fullPath: "/transactions/$orderId"
      preLoaderRoute: typeof AuthedTransactionsOrderIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/webhook-events/": {
      id: "/_authed/webhook-events/"
      path: "/webhook-events"
      fullPath: "/webhook-events/"
      preLoaderRoute: typeof AuthedWebhookEventsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/webhook-events/$eventId": {
      id: "/_authed/webhook-events/$eventId"
      path: "/webhook-events/$eventId"
      fullPath: "/webhook-events/$eventId"
      preLoaderRoute: typeof AuthedWebhookEventsEventIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedBridgeShopifyOrderIdRoute: typeof AuthedBridgeShopifyOrderIdRoute
  AuthedCallbacksDeliveryIdRoute: typeof AuthedCallbacksDeliveryIdRoute
  AuthedDisbursementsDisbursementIdRoute: typeof AuthedDisbursementsDisbursementIdRoute
  AuthedMerchantsMerchantIdRoute: typeof AuthedMerchantsMerchantIdRoute
  AuthedSettlementsSettlementIdRoute: typeof AuthedSettlementsSettlementIdRoute
  AuthedStorefrontsStorefrontIdRoute: typeof AuthedStorefrontsStorefrontIdRoute
  AuthedStorefrontsNewRoute: typeof AuthedStorefrontsNewRoute
  AuthedTransactionsOrderIdRoute: typeof AuthedTransactionsOrderIdRoute
  AuthedWebhookEventsEventIdRoute: typeof AuthedWebhookEventsEventIdRoute
  AuthedAuditLogIndexRoute: typeof AuthedAuditLogIndexRoute
  AuthedBridgeIndexRoute: typeof AuthedBridgeIndexRoute
  AuthedCallbacksIndexRoute: typeof AuthedCallbacksIndexRoute
  AuthedDisbursementsIndexRoute: typeof AuthedDisbursementsIndexRoute
  AuthedMerchantsIndexRoute: typeof AuthedMerchantsIndexRoute
  AuthedPaymentConflictsIndexRoute: typeof AuthedPaymentConflictsIndexRoute
  AuthedSettlementsIndexRoute: typeof AuthedSettlementsIndexRoute
  AuthedStorefrontsIndexRoute: typeof AuthedStorefrontsIndexRoute
  AuthedTransactionsIndexRoute: typeof AuthedTransactionsIndexRoute
  AuthedWebhookEventsIndexRoute: typeof AuthedWebhookEventsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedBridgeShopifyOrderIdRoute: AuthedBridgeShopifyOrderIdRoute,
  AuthedCallbacksDeliveryIdRoute: AuthedCallbacksDeliveryIdRoute,
  AuthedDisbursementsDisbursementIdRoute:
    AuthedDisbursementsDisbursementIdRoute,
  AuthedMerchantsMerchantIdRoute: AuthedMerchantsMerchantIdRoute,
  AuthedSettlementsSettlementIdRoute: AuthedSettlementsSettlementIdRoute,
  AuthedStorefrontsStorefrontIdRoute: AuthedStorefrontsStorefrontIdRoute,
  AuthedStorefrontsNewRoute: AuthedStorefrontsNewRoute,
  AuthedTransactionsOrderIdRoute: AuthedTransactionsOrderIdRoute,
  AuthedWebhookEventsEventIdRoute: AuthedWebhookEventsEventIdRoute,
  AuthedAuditLogIndexRoute: AuthedAuditLogIndexRoute,
  AuthedBridgeIndexRoute: AuthedBridgeIndexRoute,
  AuthedCallbacksIndexRoute: AuthedCallbacksIndexRoute,
  AuthedDisbursementsIndexRoute: AuthedDisbursementsIndexRoute,
  AuthedMerchantsIndexRoute: AuthedMerchantsIndexRoute,
  AuthedPaymentConflictsIndexRoute: AuthedPaymentConflictsIndexRoute,
  AuthedSettlementsIndexRoute: AuthedSettlementsIndexRoute,
  AuthedStorefrontsIndexRoute: AuthedStorefrontsIndexRoute,
  AuthedTransactionsIndexRoute: AuthedTransactionsIndexRoute,
  AuthedWebhookEventsIndexRoute: AuthedWebhookEventsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
